var els = $('.prices-container');
if (els.length > 0) {
  require.ensure('../listings/price_fields', function(require) {
    var PriceFields = require('../listings/price_fields');
    els.each(function() {
      return new PriceFields(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/price_fields.initializer.js